




































































import Vue from 'vue'
import { ValuationPreview } from '@/interfaces/valuation/ValuationRecord'
import { ValuationRecordsPagination } from '@/types/store/valuation'

export default Vue.extend({
  created() {
    this.$store.dispatch('valuationRecords/fetchPreviews')
  },
  computed: {
    previews(): ValuationPreview[] {
      return this.$store.getters['valuationRecords/previews']
    },
    pagination(): ValuationRecordsPagination {
      return this.$store.getters['valuationRecords/pagination']
    },
    currentPage: {
      get(): number {
        return this.pagination.current
      },
      set(val: number): void {
        this.$store.dispatch('valuationRecords/changePage', val)
      },
    },
    perPage: {
      get(): number {
        return this.pagination.perPage
      },
      set(val: number): void {
        this.$store.dispatch('valuationRecords/changePerPage', val)
      },
    },
  },
})
